import { __assign } from "tslib";
export default (function (state, action) {
    switch (action.type) {
        case 'updateAltText': {
            return __assign({}, state);
        }
        case 'openMediaAltTextMenu': {
            return __assign(__assign({}, state), { isAltTextEditorOpen: true });
        }
        case 'closeMediaAltTextMenu': {
            return __assign(__assign({}, state), { isAltTextEditorOpen: false });
        }
        default:
            return state;
    }
});
//# sourceMappingURL=reducer.js.map